import { watch } from 'vue'

import type { OnboardingFormData } from '../lib/onboardingPrefill'

/**
 * US "I work independently – my brokerage name is the same as my name above".
 *
 * While ticked, `brokerageName` follows `name` (including edits made on the
 * review step or by AI capture). Unticking keeps the current value and makes
 * the field editable again. Runs inside `useOnboardingForm` so it keeps syncing
 * regardless of which step (form, review, AI capture) changes the name.
 */
export function useBrokerageSameAsName(options: {
  formData: OnboardingFormData
  setField: (field: string, value: string) => void
}) {
  const { formData, setField } = options

  watch(
    () => [formData.brokerageNameSameAsName, formData.name] as const,
    ([checked, name]) => {
      if (!checked) return
      const value = name ?? ''
      if (formData.brokerageName !== value) setField('brokerageName', value)
    }
  )
}
